import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=7e436d62&"
import script from "./Talk.vue?vue&type=script&lang=js&"
export * from "./Talk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports